<template>
  <Icon
    class="icon"
    :name="makeIconName"
    :class="outlined ? 'material-icons-outlined' : 'material-icons'"
    mode="css"
  />
</template>

<script setup lang="ts">
const props = defineProps<{ icon: string; outlined?: boolean }>();

const makeIconName = computed((): string => {
  const prefix = "ic-";
  if (props.outlined) {
    return prefix + "outline-" + props.icon;
  } else return prefix + props.icon;
});
</script>

<style lang="scss">
.icon {
  max-height: 100%;
  font-size: 1.5rem;
  width: 1.5rem;
  height: 1.5rem;
  user-select: none !important;

  &.interactive {
    cursor: pointer;
  }

  &.size-12 {
    font-size: 0.75rem;
    width: 0.75rem;
    height: 0.75rem;
  }
  &.size-16 {
    font-size: 1rem;
    width: 1rem;
    height: 1rem;
  }
  &.size-18 {
    font-size: 1.125rem;
    width: 1.125rem;
    height: 1.125rem;
  }

  &.size-20 {
    font-size: 1.25rem;
    width: 1.25rem;
    height: 1.25rem;
  }
  &.size-26 {
    font-size: 1.625rem;
    width: 1.625rem;
    height: 1.625rem;
  }
  &.size-26px {
    font-size: 26px;
    width: 26px;
    height: 26px;
  }
  &.size-32 {
    font-size: 2rem;
    width: 2rem;
    height: 2rem;
  }
  &.size-48 {
    font-size: 3rem;
    width: 3rem;
    height: 3rem;
  }
  &.size-52 {
    font-size: 3.25rem;
    width: 3.25rem;
    height: 3.25rem;
  }

  &.light {
    color: $light-100;
  }

  &.gray {
    color: $dark-50;
  }

  &.light-gray {
    color: $light-70;
  }
}
</style>
